import { GlobalStylesPlk } from '@rbilabs/components-library/build/globalStyles';

export const BrandGlobalStyles = GlobalStylesPlk;
